<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
  variant: {
    type: String,
    default: 'wordmark',
    validator: (value) => ['symbol', 'tile', 'wordmark'].includes(value),
  },
  color: { type: String, default: 'currentColor' },
  title: { type: String, default: null },
});

const label = computed(() => props.title ?? usePage().props.appName);

// Rounded dark tile with muted bars, the same geometry as the brand package's 04_Favicon/favicon.svg.
const tile = { x: -1.351, y: -1.351, width: 102.703, height: 102.703, rx: 22.595 };

const symbolBars = [
  { x: 36, y: 13 },
  { x: 24, y: 40 },
  { x: 12, y: 67 },
];

const wordmarkPaths = [
    'M 500.246094 243.089844 L 500.246094 200.054688 C 500.246094 186.746094 511.015625 175.960938 524.296875 175.960938 C 537.578125 175.960938 548.34375 186.746094 548.34375 200.054688 L 548.34375 243.089844 C 548.34375 252.171875 555.691406 259.535156 564.757812 259.535156 C 573.820312 259.535156 581.167969 252.171875 581.167969 243.089844 L 581.167969 202.550781 C 581.167969 171.082031 555.707031 145.566406 524.296875 145.566406 C 492.886719 145.566406 467.425781 171.082031 467.425781 202.550781 L 467.425781 243.089844 C 467.425781 252.171875 474.773438 259.535156 483.835938 259.535156 C 492.902344 259.535156 500.246094 252.171875 500.246094 243.089844 Z M 500.246094 243.089844',
    'M 338.640625 226.285156 L 289.804688 226.285156 C 287.035156 226.285156 284.789062 224.035156 284.789062 221.261719 C 284.789062 218.488281 287.035156 216.238281 289.804688 216.238281 L 341.066406 216.238281 C 348.75 216.238281 354.980469 209.996094 354.980469 202.296875 C 354.980469 194.597656 348.75 188.359375 341.066406 188.359375 L 289.804688 188.359375 C 287.035156 188.359375 284.789062 186.109375 284.789062 183.335938 C 284.789062 180.558594 287.035156 178.308594 289.804688 178.308594 L 338.640625 178.308594 C 347.664062 178.308594 354.980469 170.980469 354.980469 161.9375 C 354.980469 152.898438 347.664062 145.566406 338.640625 145.566406 L 303.792969 145.566406 C 275.527344 145.566406 252.609375 168.527344 252.609375 196.851562 L 252.609375 207.742188 C 252.609375 236.066406 275.527344 259.027344 303.792969 259.027344 L 338.640625 259.027344 C 347.664062 259.027344 354.980469 251.699219 354.980469 242.65625 C 354.980469 233.617188 347.664062 226.285156 338.640625 226.285156 Z M 338.640625 226.285156',
    'M 446.066406 226.285156 L 397.226562 226.285156 C 394.457031 226.285156 392.214844 224.035156 392.214844 221.261719 C 392.214844 218.488281 394.457031 216.238281 397.226562 216.238281 L 448.492188 216.238281 C 456.175781 216.238281 462.402344 209.996094 462.402344 202.296875 C 462.402344 194.597656 456.175781 188.359375 448.492188 188.359375 L 397.226562 188.359375 C 394.457031 188.359375 392.214844 186.109375 392.214844 183.335938 C 392.214844 180.558594 394.457031 178.308594 397.226562 178.308594 L 446.066406 178.308594 C 455.089844 178.308594 462.402344 170.980469 462.402344 161.9375 C 462.402344 152.898438 455.089844 145.566406 446.066406 145.566406 L 411.21875 145.566406 C 382.949219 145.566406 360.035156 168.527344 360.035156 196.851562 L 360.035156 207.742188 C 360.035156 236.066406 382.949219 259.027344 411.21875 259.027344 L 446.066406 259.027344 C 455.089844 259.027344 462.402344 251.699219 462.402344 242.65625 C 462.402344 233.617188 455.089844 226.285156 446.066406 226.285156 Z M 446.066406 226.285156',
    'M 171.058594 243.832031 C 171.058594 252.222656 164.265625 259.027344 155.890625 259.027344 L 153.996094 259.027344 C 145.621094 259.027344 138.832031 252.222656 138.832031 243.832031 L 138.832031 160.765625 C 138.832031 152.371094 145.621094 145.566406 153.996094 145.566406 L 156.800781 145.566406 C 164.675781 145.566406 171.058594 151.964844 171.058594 159.855469 C 171.058594 172.117188 185.464844 178.683594 194.6875 170.621094 L 219.09375 149.285156 C 221.835938 146.890625 225.351562 145.566406 228.988281 145.566406 C 242.859375 145.566406 249.34375 162.773438 238.9375 171.960938 L 225.410156 183.902344 C 219.230469 189.355469 218.527344 198.75 223.816406 205.070312 L 268.710938 258.683594 C 268.730469 258.707031 268.742188 258.730469 268.75 258.757812 C 268.792969 258.890625 268.691406 259.027344 268.550781 259.027344 L 230.695312 259.027344 C 226.054688 259.027344 221.667969 256.898438 218.792969 253.25 L 200.195312 229.65625 C 194.660156 222.632812 184.289062 221.902344 177.824219 228.082031 L 175.753906 230.0625 C 172.753906 232.929688 171.058594 236.902344 171.058594 241.058594 Z M 171.058594 243.832031',
];

const layouts = {
  symbol: {
    viewBox: '12 13 76 74',
    wordmarkTransform: null,
  },
  tile: {
    viewBox: '-1.351 -1.351 102.703 102.703',
    wordmarkTransform: null,
  },
  wordmark: {
    viewBox: '0 0 442.4 114.1',
    wordmarkTransform: 'translate(-138.8 -145.5)',
  },
};

const layout = computed(() => layouts[props.variant]);

const hasSymbol = computed(() => props.variant !== 'wordmark');

const isTile = computed(() => props.variant === 'tile');
</script>

<template>
  <svg
    :viewBox="layout.viewBox"
    :fill="isTile ? null : color"
    :class="{ 'fill-brand-muted': isTile }"
    role="img"
    :aria-label="label"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect v-if="isTile" data-testid="keen-tile" v-bind="tile" class="fill-brand-dark" />
    <g v-if="hasSymbol" data-testid="keen-symbol">
      <rect v-for="bar in symbolBars" :key="bar.y" :x="bar.x" :y="bar.y" width="52" height="20" rx="10" />
    </g>
    <g v-if="layout.wordmarkTransform" data-testid="keen-wordmark" :transform="layout.wordmarkTransform">
      <path v-for="path in wordmarkPaths" :key="path" :d="path" />
    </g>
  </svg>
</template>
